import { createContext } from 'react';

export const loggingContext = createContext({});

export const LoggingProvider = ({ children, api }) => {
  // when the assessment has been completed and before the results are retrieved
  const trackAssessmentFinished = ({ assessmentId, agencyClient }) => {
    return api.events.assessmentFinished({ assessmentId, agencyClient });
  };

  // call once for the assessment, after it is loaded
  const trackAssessmentViewed = ({ assessmentId }) => {
    return api.events.assessmentViewed({ assessmentId });
  };

  // track when an assessment has been started
  const trackAssessmentStarted = ({ assessmentId, agencyClient }) => {
    return api.events.assessmentStarted({ assessmentId, agencyClient });
  };

  // in some cases we want to log an event that an assessment's status changed
  const trackAssessmentStatusMarked = ({ assessmentId, status }) => {
    return api.events.assessmentStatusMarked({ assessmentId, status });
  };

  // after any assessment question is answered
  const trackAnsweredQuestion = ({ assessmentId, questionId, agencyClientId }) => {
    return api.events.answeredQuestion({ assessmentId, questionId, agencyClientId });
  };

  return (
    <loggingContext.Provider
      value={{
        reqParams: api.reqParams,
        alert: api.alert,
        trackAssessmentFinished,
        trackAssessmentStarted,
        trackAssessmentStatusMarked,
        trackAssessmentViewed,
        trackAnsweredQuestion
      }}
    >
      {children}
    </loggingContext.Provider>
  );
};
